// TODO: get this information from sass
export const WEBSITE_BREAKPOINTS = {
  SMALL: 703,
  MEDIUM: 1279,
  LARGE: 1679,
}
